import React from "react";
import { Label } from "semantic-ui-react";

import "./Label.scss";

export default function LabelTotal({ label, data }) {
  return (
    <div className="labelTotal">
      <label>{label}</label> <Label className="labelTotal__label">{data}</Label>
    </div>
  );
}
